import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDownIcon, UsersIcon, PhoneOffIcon, UserMinusIcon, DollarSignIcon } from 'lucide-react';
const painPoints = [{
  icon: TrendingDownIcon,
  text: 'Agentes que ganan bien un mes y al siguiente no saben de dónde saldrá el próximo cliente.'
}, {
  icon: UsersIcon,
  text: 'Agency owners que reclutan personas, pero pocas se activan.'
}, {
  icon: PhoneOffIcon,
  text: 'Equipos que dependen de motivación, llamadas en frío o referidos.'
}, {
  icon: UserMinusIcon,
  text: 'Reclutas que desaparecen porque nadie les da seguimiento.'
}, {
  icon: DollarSignIcon,
  text: 'Dinero perdido en agencias genéricas que no conocen seguros.'
}];
export function ProblemSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-white relative border-t border-brand-gold/10" data-id="element-101">
      <div className="max-w-5xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-103">
          <h2 className="font-heading font-bold text-3xl md:text-5xl uppercase tracking-tight text-brand-text mb-6" data-id="element-104">
            El mercado hispano de seguros no está roto por falta de esfuerzo
            <br data-id="element-105" />
            <span className="text-brand-gold" data-id="element-106">
              Está roto por falta de estructura
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-107">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-brand-charcoal border border-brand-gold/20 p-6 rounded-lg hover:border-brand-gold/50 transition-colors shadow-sm" data-id="element-108">
              <point.icon className="w-10 h-10 text-brand-gold mb-4" data-id="element-109" />
              <p className="text-brand-text-muted leading-relaxed" data-id="element-110">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center bg-brand-dark border border-brand-gold/30 p-8 rounded-xl shadow-[0_0_30px_rgba(200,149,43,0.1)]" data-id="element-111">
          <h3 className="font-heading font-bold text-2xl md:text-3xl uppercase text-brand-gold" data-id="element-112">
            No necesitas más improvisación. Necesitas control
          </h3>
        </motion.div>
      </div>
    </section>;
}